import Pane from 'components/Common/Pane'
import { rem } from 'polished'
import styled, { css } from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { LOYALTY_CREDIT_CARD_COLOUR_CREAM } from '../loyaltyCreditCardConstants'

export const LoyaltyCreditCardSection = styled(Pane)`
  padding: ${rem(40)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(64)} 0;
  }
`

export const LoyaltyCreditCardCreamSection = styled(LoyaltyCreditCardSection)`
  && {
    background: ${LOYALTY_CREDIT_CARD_COLOUR_CREAM};
  }
`

export const loyaltyCreditCardCardShadow = css`
  box-shadow: 0 1px 1.5px rgba(0,0,0,0.07), 0 1.5px 2.5px rgba(0,0,0,0.05), 0 5px 5px rgba(0,0,0,0.05), 0 15px 16px rgba(0,0,0,0.04);
`

/* LuxKit buttons keep their label on one line and never shrink, so a longer
   translation runs past the edge of its column and drags the whole page
   sideways. Let the label wrap and the button grow taller to fit it. English
   labels are short enough to stay on one line, so they keep the Figma button. */
export const loyaltyCreditCardWrappingLabel = css`
  &:not(:lang(en)) {
    white-space: normal;
    height: auto;
    min-height: var(--button-height);
    padding-block: ${rem(8)};
  }
`
